<template>
  <div class="home" ref="screenDom">
    <div class="canvas-container"></div>
  </div>
</template>

<script setup>
//引入生命周期中的两个
import { onMounted, onUnmounted, ref } from "vue";
import ThreePlus from "../three/index";
import * as THREE from "three";
import eventHub from "@/utils/eventHub";


let screenDom = ref(null);
const resizeFn = () => {
  // console.log(screenDom);
  let scale = window.innerWidth / 1920;
  screenDom.value.style.transform = `scale(${scale})`;
};
onMounted(() => {
  resizeFn();
  window.addEventListener("resize", resizeFn);
});

onMounted(() => { 
  const container = document.querySelector(".canvas-container");
  let threePlus = new ThreePlus(".canvas-container");


  //1 增加背景环幕  增加后 天地 变亮 否则是一片黑暗
  threePlus.setBg("./assets/textures/023.hdr")  ;

  //2 添加云雾效果
    // threePlus.addClouds();
    // threePlus.addCloudsPlus();

  //3 添加海洋
    // threePlus.addOcean();


//4  加载模型
//ball    fudong3m   /city/metaScene03
threePlus.gltfLoader("./model/fudong3m.glb").then((gltf) => {

        //只有用府东的才转换， 模型导出反了
        gltf.scene.rotation.x=Math.PI ;
        //转换后高度位置有变化  增加2米
        gltf.scene.position.set(0,2,0);
        //能改位置，但是其他的都需要改，还是改机器人的位置吧
        // gltf.scene.position.set(3,2,3);
        // photo[flag].rotation.y=Math.PI/180*ry;
        // photo[flag].rotation.z=Math.PI/180*rz;


    // console.log(gltf);

    let planeGroup = new THREE.Group();
    planeGroup.position.copy(gltf.scene.children[0].position);

    // 这个地方很有意思， 是再循环中加需要碰撞的物体，采用给第一句gltf.scene.add(planeGroup);  但是fudong3m模型不行
    // 采用第二句，fudong3m模型可以
    // gltf.scene.add(planeGroup);




    planeGroup.add(gltf.scene);


    //根据材质添加碰撞物体  
    //玻璃材质   墙壁发光材质   边框材质  白边框材质   地板
    gltf.scene.traverse((child) => {
      // if (
      //   child.isMesh &&
      //   child.material &&
      //   child.material.name.indexOf("KB3D_DLA_ConcreteRiverRock") != -1
      // ) {
      //   // console.log("地面", child);
      //   // child.material.color.set(0xffffff);
      //   // child.material.map = null;
      //   planeGroup.add(child.clone());
      //   child.visible = false;
      // }
      // if (
      //   child.isMesh &&
      //   child.material &&
      //   child.material.name.indexOf("KB3D_DLA_ConcreteScreedTan") != -1
      // ) {
      //   // console.log("墙", child);
      //   planeGroup.add(child.clone());
      //   child.visible = false;
      // }
      // if (
      //   child.isMesh &&
      //   child.material &&
      //   child.material.name.indexOf("KB3D_DLA_ConcretePittedGrayLight") != -1
      // ) {
      //   // console.log("光墙", child);
      //   planeGroup.add(child.clone());
      //   child.visible = false;
      // }
    });


           // 创建一个平面  自添加  补充地板
       const planeGeometry = new THREE.PlaneGeometry(55, 30, 1, 1);
        const planeMaterial = new THREE.MeshBasicMaterial({
        color: 0xff0000,
        side: THREE.DoubleSide,
       });
      planeMaterial.name="地板";
      const plane = new THREE.Mesh(planeGeometry, planeMaterial);
       plane.receiveShadow = true;
       plane.rotation.x = -Math.PI / 2;
       plane.position.set(0,-0.001,0);
    


    planeGroup.add(plane);
    threePlus.addPhysics(planeGroup);
    threePlus.scene.add(gltf.scene);












    //5  添加测试视频平面
    threePlus.addVideoPlane("./video/test.mp4");
    let dirPlane = threePlus.addVideoPlane(
      "./video/test.mp4",
      new THREE.Vector2(2, 2)
    );
    dirPlane.mesh.position.set(-1.5, 3, 2);
    // dirPlane.mesh.position.set(0, 0, 0);
    // dirPlane.mesh.rotation.x = -Math.PI / 2;
    dirPlane.mesh.rotation.z = -Math.PI / 2;

    // 添加喷泉旁的光阵视频纹理
    let lightPlane = threePlus.addVideoPlane(
      "./video/zp2.mp4",
      new THREE.Vector2(5, 3),
      new THREE.Vector3(-3, -0.3, 15)
    );
    lightPlane.mesh.rotation.x = -Math.PI / 2;
    //模型窗外
    let lightCirclePosition = new THREE.Vector3(-3, -0.3, 15);
    //模型窗外  照片墙前
     lightCirclePosition = new THREE.Vector3(-15.6,1.2,-7.45);

    let lightCircle = threePlus.addLightCircle(lightCirclePosition);
    let fireSprite = null;
    // 监听是否进入光阵
    threePlus.physics.onPosition(
      lightCirclePosition,
      (eventData) => {
        console.log("触发进入光圈");

        //进入翻书程序
              console.log("跳转书本");
              //1 在原来窗口打开，回到原始界面比较慢
              // window.location.href = `https://xtdsc.com/ebook/?bookid=2`;
              //2 在新的窗口打开， 点击原来网页直接回到原来窗口
              // window.open('https://xtdsc.com/ebook/?bookid=2', '_blank');
              //3 在新的窗口打开书架， 点击原来网页直接回到原来窗口
              window.open('https://xtdsc.com/booktree', '_blank');


              //回到3D后，有时继续保持了持续的向前运动，怎么解决？
              //只要在快接近的时候， 把键盘按下后起来就可以， 否则会记忆一直按，重新回到原来位置
    // this.keyStates = {
    //   KeyW: false,
    //   KeyA: false,
    //   KeyS: false,
    //   KeyD: false,
    //   Space: false,
    //   isDown: false,
    // };
  //增加后  不动了
    // this.keyStates = {
    //   KeyW: true,
    //   KeyA: true,
    //   KeyS: true,
    //   KeyD: true,
    //   Space: true,
    //   isDown: true,
    // };


        lightCircle.mesh.visible = false;
        let canvasPosition = new THREE.Vector3(-3, 1.3, 18);
        // canvasPosition = new THREE.Vector3(-15.6,1.2,-7.45); //照片墙前面
        let canvasRotation = new THREE.Euler(0, Math.PI, 0);
        let canvasPlane = threePlus.addCanvasPlane(
          "恭喜到达指定位置",
          canvasPosition,
          canvasRotation
        );

        let textVideo = threePlus.addTextVideo(
          "新天地元宇宙入口",
          canvasPosition,
          canvasRotation
        );

        // 添加火焰
        fireSprite || (fireSprite = threePlus.addFireSprite());
      },
      (eventData) => {
        console.log("触发离开光圈");
        // canvasPosition.mesh.visible= false;
        lightCircle.mesh.visible = true;
      }
    );
  });


  var dummys = {};
  var photo= {};

  //初始化相框
  // initphoto(1,1805,260,0,0,90,0,120,60,5,"./images/xtdtwd.jpg");
  //位置1 通过控制坐标移动，保存到数据库中，然后调入加载  推荐   第三步
  //2通过blender测量，直接输入数据                     推荐   第一步
  //3blender建立模型的时候，直接贴纹理  增加相框        推荐   第二步
  initphoto(1,  -19.6,1.6,0,     0,90,0, 0.9,0.40,0.01,"./images/xtdtwd.jpg");
  initphoto(1,  -23.7,1.4,0.1, 0,90,0, 0.6,0.6,0.01,"./images/国画葡萄紫气东来.jpg");
  initphoto(1,  -23.7,1.2,5.01, 0,90,0, 2,1.3,0.01,"./images/国画山水旭日东升.jpg");
  initphoto(1,  -4.38,1.6,-4, 0,90,0, 1.6,0.4,0.01,"./images/国画山水九宝山.jpg");
  
  initphoto(1,   7.6,1.6,-4.4,       0,90,0,2,0.80,0.01,"./images/国画锦鸡.jpg");
  initphoto(1,   6,1.2,-9,       0,0,0,  0.4,1.6,0.01,"./images/书法行书精气神奎伟.jpg");

  initphoto(1,   11.5,1.2,-7.4, 0,90,0,   0.8,1.60,0.01,"./images/国画荷花陆山1.jpg");
  initphoto(1,  12.5,1.2,-7.5,  0,90,0,   0.8,1.40,0.01,"./images/国画菊花1.jpg");
  initphoto(1,  -14,1.6,7.4,    0,0,0,    1,0.6,0.01,"./images/国画行书上善若水杨久信.jpg");
  initphoto(1,  11.9,1.6,1.8,   0,90,0,   1,0.6,0.01,"./images/国画花卉.jpg");

  initphoto(1,  -19.4,1.2,-7.53,  0,90,0,   0.4,1.40,0.01,"./images/书法行书赶路要紧.jpg");
  initphoto(1,  12,1.2,-6,        0,90,0,   2,1,0.01,"./images/书法楷书2008奥运李大坤.jpg");
  initphoto(1,  -23.7,1.2,-1.5,   0,90,0,   0.8,1.4,0.01,"./images/书法隶书敬业铭.jpg");
  initphoto(1,  4,1.6,-2,      0,90,0,    0.8,0.40,0.01,"./images/书法行书禅茶一味汤玉铭.jpg");
  initphoto(1, 3.72,1.4,-4,    0,90,0,    1.9,1,0.01,"./images/书法行书沁园春雪.jpg");
  initphoto(1, -12.33,1.6,4,   0,90,0,    1.6,0.40,0.01,"./images/书法行书孝悌忠信.jpg");
  initphoto(1,  3.87,1.2,-7.4, 0,90,0,    0.8,1.40,0.01,"./images/书法行书家风好.jpg");
  initphoto(1, -11.92,1.2,-2,  0,90,0,    1.4,1.40,0.01,"./images/国画行书陋室铭胡雪峰.jpg");



  initphoto(1,-19.6,1.4,5.6, 0,90,0, 0.6,0.40,0.01,"./images/新天地资质证书公关委儿童团.jpg");
  initphoto(1,-19.6,1.8,5.6, 0,90,0, 0.6,0.40,0.01,"./images/新天地资质证书爱心企业1.jpg");
  initphoto(1,-19.6,1.8,5.6, 0,90,0, 0.6,0.40,0.01,"./images/新天地资质证书爱心企业.jpg");
  initphoto(1,-19.6,1.8,5,   0,90,0, 0.6,0.40,0.01,"./images/新天地资质证书百家诚信单位.jpg");
  initphoto(1,-19.6,1.8,4.4, 0,90,0, 0.6,0.40,0.01,"./images/新天地资质证书诚信企业.jpg");
  initphoto(1,-19.6,1.8,3.8, 0,90,0, 0.6,0.40,0.01,"./images/新天地资质证书高新技术企业.jpg");
  initphoto(1,-19.6,1.4,5,   0,90,0, 0.6,0.4,0.01,"./images/新天地资质证书守法诚信企业.jpg");
  initphoto(1,-19.6,1.4,4.4, 0,90,0, 0.6,0.4,0.01,"./images/新天地资质证书沂蒙名商.jpg");
  initphoto(1,-19.6,1.4,3.8, 0,90,0, 0.6,0.4,0.01,"./images/新天地资质证书直属企业会员.jpg");




  initphoto(21,-4.5,1.6,3.1,  0,90,0, 0.6,0.4,0.01,"./images/新天地爱心企业.jpg");
  initphoto(22,-4.5,1.6,3.7,  0,90,0, 0.6,0.40,0.01,"./images/新天地安防一级资质.jpg");
  initphoto(23,-4.5,1.6,4.3,  0,90,0, 0.6,0.40,0.01,"./images/新天地诚信企业.jpg");
  initphoto(24,-4.5,1.2,3.1,  0,90,0, 0.6,0.40,0.01,"./images/新天地高新技术企业.jpg");
  initphoto(25,-4.5,1.2,3.7,  0,90,0, 0.6,0.40,0.01,"./images/新天地公司.jpg");
  initphoto(26,-4.5,1.2,4.3,  0,90,0, 0.6,0.40,0.01,"./images/新天地资质电信增值.jpg");

// function initphoto(flag, x, y, z, rx,ry,rz,length,height,thicknes,url)


  initphoto(1,-15.6,1.2,-7.45, 0,0,0, 0.6,0.40,0.01,"./images/新天地监控.png");
  initphoto(1,-14.8,1.2,-7.45, 0,0,0, 0.6,0.4,0.01,"./images/新天地道闸.png");
  initphoto(1,-14.0,1.2,-7.45, 0,0,0, 0.6,0.40,0.01,"./images/新天地大屏幕.png");
  initphoto(1,-13.2,1.2,-7.45, 0,0,0, 0.6,0.40,0.01,"./images/新天地网络.png");

  initphoto(29,-13.4,1.2,-.6,   0,0,0, 0.6,0.40,0.01,"./images/新天地安防.png");

  initphoto(31,-13.2,1.2,3.8, 0,0,0, 0.6,0.40,0.01,"./images/新天地灯光.png");
  initphoto(32,-13.1,1.2,5,   0,0,0, 0.6,0.4,0.01,"./images/新天地音响.png");

  initphoto(1,-12.9,1.2,4.4,  0,0,0, 0.6,0.4,0.01,"./images/新天地保密室.png");
  initphoto(1,-12.8,1.2,3.8,  0,0,0, 0.6,0.4,0.01,"./images/新天地安全产品.png");

  initphoto(1,-12.6,1.2,3.8,  0,0,0, 0.6,0.4,0.01,"./images/新天地软件.png");
  initphoto(1,-12.5,1.2,3.8,  0,0,0, 0.6,0.4,0.01,"./images/新天地机房.png");
  initphoto(1,-12.4,1.2,3.8,  0,0,0, 0.6,0.4,0.01,"./images/新天地演播厅.png");
  





  // 添加灯光
  threePlus.setLight();


    //初始化相框  效果和textureloader一样模糊
    function initphoto2(flag, x, y, z, rx,ry,rz,length,height,thicknes,url) {

      dummys[flag] = new THREE.Object3D();
    // 图片加载器
    var ImageLoader = new THREE.ImageLoader();
    // load方法回调函数，按照路径加载图片，返回一个html的元素img对象
    ImageLoader.load(url, function(img) {
  // image对象作为参数，创建一个纹理对象Texture
  var texture = new THREE.Texture(img);
  // 下次使用纹理时触发更新
  texture.needsUpdate = true;

        var photoogeometry = new THREE.BoxGeometry(length, height,thicknes );
        var photomaterial = new THREE.MeshBasicMaterial({
            map: texture,
            transformControls:true,
            color: 0xffffff,
        });
        photomaterial.opacity = 1.0;
        photomaterial.transparent = true;
        photo[flag] = new THREE.Mesh(photoogeometry, photomaterial);

        photo[flag].rotation.x=Math.PI/180*rx;
        photo[flag].rotation.y=Math.PI/180*ry;
        photo[flag].rotation.z=Math.PI/180*rz;
        // photo[flag].position.set(-50, 0, 0);
        photo[flag].position.set(x, y, z);
        // console.log( photo[flag]);

        threePlus.scene.add(photo[flag]);
    });
}

//模糊改进后的
function initphoto1(flag, x, y, z, rx, ry, rz, length, height, thicknes, url) {
  // dummys[flag] = new THREE.Object3D();
  
  // 使用TextureLoader加载纹理
  const textureLoader = new THREE.TextureLoader();
  textureLoader.load(url, (texture) => {
    // 高清纹理配置
    texture.minFilter = THREE.LinearFilter; // 禁用mipmap缩小过滤（适合高清图）
    texture.magFilter = THREE.LinearFilter; // 放大时线性插值
    texture.anisotropy = threePlus.renderer.capabilities.getMaxAnisotropy(); // 增强斜向观察清晰度
    texture.needsUpdate = true;

    // 确保几何体尺寸与图片比例一致（可选，根据需求调整）
    const img = new Image();
    img.src = url;
    img.onload = () => {
      const aspect = img.width / img.height;
      // 按图片比例调整几何体尺寸（例如固定高度，计算宽度）
      const adjustedLength = height * aspect;
      const photoogeometry = new THREE.BoxGeometry(adjustedLength, height, thicknes);

      const photomaterial = new THREE.MeshBasicMaterial({
        map: texture,
        color: 0xffffff,
        transparent: true, // 仅当需要透明时启用
      });

      photo[flag] = new THREE.Mesh(photoogeometry, photomaterial);
      // 设置位置和旋转
      photo[flag].rotation.set(
        THREE.MathUtils.degToRad(rx),
        THREE.MathUtils.degToRad(ry),
        THREE.MathUtils.degToRad(rz)
      );
      photo[flag].position.set(x, y, z);

      threePlus.scene.add(photo[flag]);
    };
  });
}
//豆包优化  2025-10-29
function initphoto(flag, x, y, z, rx, ry, rz, length, height, thicknes, url) {
  dummys[flag] = new THREE.Object3D();
  
  const textureLoader = new THREE.TextureLoader();
  textureLoader.load(url, (texture) => {
    // 高清纹理配置
    texture.minFilter = THREE.LinearMipmapLinearFilter; // 缩小优化
    texture.magFilter = THREE.LinearFilter;
    texture.anisotropy = threePlus.renderer.capabilities.getMaxAnisotropy();
    texture.needsUpdate = true;

    // 从纹理中获取图片尺寸（避免重复加载）
    const img = texture.image;
    const aspect = img.width / img.height;
    const adjustedLength = height * aspect; // 按图片比例计算宽度

    // 使用平面几何体，确保纹理仅映射到单个面
    const photoogeometry = new THREE.PlaneGeometry(adjustedLength, height, 1, 1);

    const photomaterial = new THREE.MeshBasicMaterial({
      map: texture,
      color: 0xffffff,
      transparent: true, // 仅当图片有透明通道时启用
    });

    photo[flag] = new THREE.Mesh(photoogeometry, photomaterial);
    // 设置旋转（使用Three.js内置的角度转换）

  // 存储bookid到Mesh对象上，方便点击时获取
    photo[flag].userData.bookid = flag; 
    // 开启可交互，支持射线检测
    photo[flag].raycastable = true; 


    photo[flag].rotation.set(
      THREE.MathUtils.degToRad(rx),
      THREE.MathUtils.degToRad(ry),
      THREE.MathUtils.degToRad(rz)
    );
    photo[flag].position.set(x, y, z);

    threePlus.scene.add(photo[flag]);

   // 绑定点击事件（需确保Three.js已配置射线检测）
    bindPhotoClickEvent(photo[flag]);


  });
}




});



// 点击事件处理函数
function bindPhotoClickEvent(photoMesh) {

   console.log('clickstrat 1');

  // 假设已创建射线检测器（需结合页面鼠标事件）
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  // 监听页面点击事件
  window.addEventListener('click', (event) => {
    // 转换鼠标坐标为Three.js标准坐标
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // 更新射线检测范围
    raycaster.setFromCamera(mouse, threePlus.camera);
    const intersects = raycaster.intersectObject(photoMesh);

    // 检测到点击当前图片
    if (intersects.length > 0) {
      const bookid = photoMesh.userData.bookid;
      // 拼接目标URL并跳转

      console.log("跳转书本");
      window.location.href = `http://aiva.com/1ebook/?bookid=${bookid}`;
    }
  });
}
</script>

<style>
.home {
  width: 1920px;
  height: 1080px;
  transform-origin: 0 0;
}
.canvas-container {
  width: 100%;
  height: 100%;
}
</style>
